export default __webpack_public_path__ + "static/media/goshen34.146826ea.jpg";